module.exports = __webpack_public_path__ + "static/media/barnesnoble.39eae682.jpg";